import Dropcursor from '@tiptap/extension-dropcursor';

export function configureDropCursor() {
  return Dropcursor.configure({
    class: 'border-dashed border-white border-2 min-h-6 min-w-2',
    color: '#131720',
  });
}
